import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { ContractService } from './../base/contract';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { OtherContract } from '../../model/other-contract';
import { Contract } from '../../model/contract';
import { Observable } from 'rxjs';

@Injectable()
export class OtherContractService extends ContractService<OtherContract> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, OtherContract, progressBar, 'other-agreement', 'OvrigaKontrakt.xlsx');
  }

  retrieveUpdatedLeaseAgreementOther(contract: Contract): Observable<any> {
    return this.client.patch(`${this.endpoint}/get-updated-other`, contract);
  }
}
